




















import Vue from 'vue';
import {IJourneyDetails} from "./JourneyDetails";
import {Component, Prop} from "vue-property-decorator";
import {IRefundStatusJourney} from "./IRefundStatusJourney";

@Component
export default class RefundComplete extends Vue {
    @Prop() details: IJourneyDetails;
    @Prop() deferred: boolean;
    @Prop() refundStatus: IRefundStatusJourney;
    
    mounted() {
        const titleParts = document.title.split(" - ");
        titleParts[0] = "Refund Complete";
        document.title = titleParts.join(" - ");
    }
}

